import styled from 'styled-components';

import { Card } from '@xing-com/card';
import { ProductType } from '@xing-com/crate-common-graphql-types';
import { mediaWide } from '@xing-com/layout-tokens';
import {
  xdlColorPremiumTertiary,
  xdlColorProJobsTertiary,
  spaceXXL,
  spaceL,
} from '@xing-com/tokens';

export const OfferBoxCard = styled(Card)<{ $product: ProductType }>`
  && {
    border: none;
    background: ${(props) =>
      props.$product === ProductType.Premium
        ? xdlColorPremiumTertiary
        : xdlColorProJobsTertiary};

    @media ${mediaWide} {
      padding: ${spaceXXL} ${spaceXXL} ${spaceL};
    }
  }
`;
